// @flow

import React, { Component }     from 'react';
import { connect }              from 'react-redux';
import { Link }                 from 'react-router-dom';
import { getTranslate }         from 'react-localize-redux';
import documentHelper           from 'helpers/document.helper';
import './success.css';

class ConfirmationSuccess extends Component {

  componentWillMount() {
    const { translate } = this.props;
    // Document page title
    documentHelper.setTitle(translate('session.confirmation.title_document_success'));
  }

  render() {
    const { translate, location } = this.props;
    let registeredEmail = location.state.registeredEmail || '';

    return(
      <div className="confirmation">
        <div className="success">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                <div className="top-header">
                  <span className="fa-stack fa-lg pull-left">
                    <i className="fa fa-circle fa-stack-2x"></i>
                    <i className="fa fa-check fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>{translate('session.confirmation.success_title')} <i>{registeredEmail}</i></h3>
                </div>
              </div>
            </div>
          </div>

          <div className="row bottom">
            <div className="col-xs-12 col-sm-3 margin-center">
              <div className="bottom-box text-center">
                <div className="nick-bg-armdown"></div>
                <div className="info-box">
                  <strong>{translate('session.common.texts.text_what_to_do_next')}</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3">
              <div className="bottom-box text-center">
                <div className="circle-arrow-group">
                  <div className="circle-arrow-right">
                    <div className="car-text text-center"><i className="fa fa-envelope"></i><strong>{translate('session.common.texts.text_check_your_email')}</strong><p>{translate('session.common.texts.text_inbox_or_spam')}</p></div>
                    <i className="car-top-left"></i>
                    <i className="car-bottom-left"></i>
                    <i className="car-middle"></i>
                    <i className="car-right"></i>
                  </div>
                  <div className="circle-arrow-left">
                    <div className="cal-text text-center"><i className="fa fa-check"></i><span>{translate('session.confirmation.text_activate_and_set_password')}</span></div>
                    <i className="cal-top-right"></i>
                    <i className="cal-bottom-right"></i>
                    <i className="cal-middle"></i>
                    <i className="cal-left"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <div className="white-box text-center">
                <div className="title">{translate('session.common.texts.success_cant_find_email')}</div>
                <div className="message">
                  <strong>{translate('session.password.success_do_a_search')}</strong>
                  <i>{translate('session.confirmation.success_search_keyword')}</i>
                </div>
                <div className="or">{translate('session.common.texts.success_or')}</div>
                <div className="message"><Link to='/session/confirmation'><strong>{translate('session.common.texts.success_request_new_one')}</strong></Link></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3 text-center fs-18">{translate('session.common.texts.success_text_have_account')} <Link to='/session/login'><strong className="semibold">{translate('session.common.button_login')}</strong></Link><br /><br /></div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3 text-center fs-14">{translate('session.common.hint.hint_checkout_faq')}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale)
});

export default connect(mapStateToProps)(ConfirmationSuccess);



// WEBPACK FOOTER //
// ./src/components/session/confirmation/success.js